var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnbHomeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40166"
  }, /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M4.99714 12.6387H3L12 3.63867L21 12.6387H19.0029",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M4.99707 12.6387V20.1029C4.99707 21.2086 5.36565 21.6387 6.47136 21.6387H17.4632C18.5689 21.6387 18.9942 21.2086 18.9942 20.1029V12.6387",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M9 21.6387V15.6387C9 14.533 9.89143 13.6416 10.9971 13.6416H12.9943C14.1 13.6416 14.9914 14.533 14.9914 15.6387V21.6387",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbHomeOff);
export default __webpack_public_path__ + "static/media/gnb_home_off.eb5536b9191b23bbc601072cf6fb2d83.svg";
export { ForwardRef as ReactComponent };